export default __webpack_public_path__ + "static/media/notification-bell.29c2390d.svg";